const date = new Date()
const todayTime = date.getFullYear() + '-' + (date.getMonth() + 1 )+ '-' + date.getDate()

export default todayTime